import { getZonesArray } from 'scripts/zones/selectors';
import { getZonesSortingCriteria } from 'util/sort';
import { getMessage } from 'util/locale';
import { _formatArea } from 'advanced/review-scenarios/zoneTableUtil';
import { get } from 'lodash';
import { getPercentage } from 'util/unit';
import { Zone } from 'store/types/types';

export const formatZoneRowsForReview = (zones: Zone[], isMultiLayerEnabled: boolean) => {
  const sortingFunction = getZonesSortingCriteria(true, isMultiLayerEnabled);
  const zonesArray = getZonesArray(zones).sort(sortingFunction);
  return zonesArray.map((zone, rowI) => {
    return {
      color: {r: 247, g: 133, b: 12},
      name: getMessage('title-text__zone', { num: rowI+1}),
      areaText: _formatArea(zone.meta.area, 1),
      area: get(zone, 'meta.area.q', 0),
      isDeadZone: zone.geoJson?.properties?.isDeadZone || false,
      relativeProductivity: getPercentage(zone.geoJson?.properties?.relativeProductivity?.v, { isPlusMinus: true }),
      yieldPerCrop: zone.geoJson?.properties?.yieldPerCrop || [],
      averageCCI: zone.geoJson?.properties?.averageCCI,
      zone
    };
  });
};
